'use client';

import { type StockItemResult } from '@app/(darkHeader)/ai/_shared/_actions/fetchStockItem';
import { useAiToolkitContext } from '@app/(darkHeader)/ai/_shared/_context/AiToolkitContext';
import { VIDEO_EDIT_FORM_DEFAULTS } from '@app/(darkHeader)/ai/_shared/_context/VideoEditFormState';
import { AI_TOOLKIT_CATEGORIES } from '@app/(darkHeader)/ai/_shared/_context/types';
import { useEffect, useRef } from 'react';

/**
 * Commits a deep-linked stock item to context and
 * updates the UI with the hydrated item after fetch.
 *
 */
export function useApplyVideoEditDeepLink(item: StockItemResult | null): void {
    const { formStates, updateFormState, dispatchVideoEditSubmit, videoSearch, submitStates } = useAiToolkitContext();
    const { setShowSearch } = videoSearch;

    const { previewUrl, thumbnailUrl, duration, contentId, aspectRatio } = item ?? {};

    const deepLinkOwnsPanel = useRef(submitStates[AI_TOOLKIT_CATEGORIES.VIDEO_EDIT].status === 'selection');

    useEffect(() => {
        if (!contentId || !deepLinkOwnsPanel.current) return;

        updateFormState(AI_TOOLKIT_CATEGORIES.VIDEO_EDIT, {
            ...(formStates[AI_TOOLKIT_CATEGORIES.VIDEO_EDIT] ?? VIDEO_EDIT_FORM_DEFAULTS),
            sourceVideo: previewUrl ?? '',
            contentId,
        });
        dispatchVideoEditSubmit({
            type: 'SELECTION',
            originalVideoUrl: previewUrl ?? '',
            originalThumbnailUrl: thumbnailUrl ?? '',
            duration: duration ?? 0,
            contentId,
            aspectRatio: aspectRatio ?? 0,
        });
        setShowSearch(false);
    }, [contentId]);
}
